import { toSimpleGroups } from '@/lib/link'
import { SecondaryPageLink } from '@/PageManager'
import { useAtomValue } from 'jotai'
import { simpleGroupsChannelAtom } from '@/atoms/invalidation'
import { HugeiconsIcon } from '@hugeicons/react'
import { Loading03Icon } from '@hugeicons/core-free-icons'
import { useTranslation } from 'react-i18next'
import { useAsync } from 'react-use'
import { loadSimpleGroups } from '@nostr/gadgets/lists'

export default function SimpleGroups({ pubkey }: { pubkey: string }) {
  const { t } = useTranslation()
  const channel = useAtomValue(simpleGroupsChannelAtom)
  const { value: data, loading } = useAsync(() => loadSimpleGroups(pubkey), [pubkey, channel])

  return (
    <SecondaryPageLink
      to={toSimpleGroups(pubkey)}
      className="flex gap-1 hover:underline w-fit items-center text-xs"
    >
      {loading ? (
        <HugeiconsIcon icon={Loading03Icon} className="animate-spin size-3" />
      ) : (
        (data?.items.length ?? 0)
      )}
      <div className="text-muted-foreground">{t('Groups')}</div>
    </SecondaryPageLink>
  )
}
